import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import Icon from "@material-ui/core/Icon";

const ENTER = 13;
const styles = theme => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    [theme.breakpoints.down("xs")]: {
      margin: theme.spacing.unit
    }
  },
  input: {
    marginLeft: 8,
    flex: 1
  },
  iconButton: {
    padding: 10
  }
});

class SearchBox extends React.Component {
  componentDidUpdate() {
    document.getElementById("inputKeyword").value = this.props.keyword;
  }

  handleClick = () => {
    let keyword = document.getElementById("inputKeyword").value;
    this.props.search(keyword);
  }

  handleKeyDown = (e) => {
    if (e.keyCode === ENTER) {
      let keyword = document.getElementById("inputKeyword").value;
      this.props.search(keyword);
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <Paper className={classes.root} elevation={1}>
        <InputBase id="inputKeyword" className={classes.input} placeholder="キーワードを入力"
          onKeyDown={this.handleKeyDown}
        />
        <IconButton className={classes.iconButton} aria-label="Search"
          onClick={this.handleClick} >
          <Icon>search</Icon>
        </IconButton>
      </Paper>
    );
  }
}

SearchBox.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SearchBox);
